module.exports = __webpack_public_path__ + "_assets/img/easyCardIcon.c3e72b52.svg";